import React, {  useEffect } from 'react';
import { connect } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import {  dcrActionCreators } from '../store/DCRStore';
import { AppState } from '../store/configureStore';
import { Dispatch,bindActionCreators, AnyAction } from 'redux';
import { helperActionCreators } from '../store/HelperStore';
import Skeleton from 'react-loading-skeleton';

type TCHomeProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const Home = (props: TCHomeProps) => {

    useEffect(() => {
        props.fetchCurrentUser();
        
    }, []);    

     return (
         <div className="row container">
             <div className="col-12 pl-2">
                 <div className="mt-2"><Skeleton width={'100%'} /></div>
                 <div><Skeleton width={'95%'} /></div>
                 <div className="mt-2"><Skeleton width={'100%'} /></div>
                 <div><Skeleton width={'95%'} /></div>
                 <div className="mt-2"><Skeleton width={'100%'} /></div>
                 <div><Skeleton width={'95%'} /></div>
                 <div className="mt-2"><Skeleton width={'100%'} /></div>
                 <div><Skeleton width={'95%'} /></div>
                 <div className="mt-2"><Skeleton width={'100%'} /></div>
                 <div><Skeleton width={'95%'} /></div>
                 <div className="mt-2"><Skeleton width={'100%'} /></div>
                 <div><Skeleton width={'95%'} /></div>
                 <div className="mt-2"><Skeleton width={'100%'} /></div>
                 <div><Skeleton width={'95%'} /></div>
             </div>
         </div>
    )
};

function mapStateToProps(state: AppState) {
    return {
        dcr: state.dcr
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators(
        {
            ...dcrActionCreators,
            ...helperActionCreators
        }, dispatch);
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Home);
